import { compose, mapProps } from 'recompose';
import config from '../../../config';
import { withFetchOnMount } from '../../Common/Spinner';

const getData = () => $.get(`${config.localeShippingApi}/productConfig`);

const dataMapper = data =>
  data.map(({ product_config_values, pbx_family_name, pbx_family_id, ...keys }) => ({
    title: pbx_family_name,
    productFamilyId: pbx_family_id,
    productTypes: product_config_values.map((config) => ({
      productFamilyId: pbx_family_id,
      ...config
    })),
    ...keys,
}));

export const withProductConfigProps = compose(
  withFetchOnMount(getData),
  mapProps(({ loading, data, ...keys }) => ({
    productConfigs: dataMapper(data),
    ...keys
  })),
)

export function fetchPbxProductConfigsData(productConfigs) {
  const query = productConfigs.map(config => `configs[]=${config}`).join('&');
  return $.get(`${config.localeApi}/pbx_product_configs?${query}`);
}

export function retrieveProductFromProductFamily(productFamilyId, lastFriendlyUrlSegment) {
  return $.get(`${config.api}/printbox/product_family/${productFamilyId}/products/friendly_url/${lastFriendlyUrlSegment}`)
}



// WEBPACK FOOTER //
// ./src/Common/Providers/ProductConfig.js